import { getEndpoint, ENDPOINT_LOENSEKTORER, ENDPOINT_STATISTICS_EXPERIENCE, ENDPOINT_STATISTICS_EDUCATION } from '../../services/service-some-api';
import { externalTooltipHandlerCustom } from './custom-tooltip';
import { SectorColors } from '../../consts/const-utils';
import { getRootVariable, setGlobalChartConfig } from '../../services/service-utils';
import { setChartScaleTitle, updateSalaryLegendStyle } from './chartjs-const';
import { EventBus, EventTypes } from '../../consts/const-event-types';


export default class ChartJSLineComparisonComponent {
  constructor(element) {
    this.el = element
  
    // Variables and config
    this.ctx = this.el.querySelector('.chart-canvas').getContext('2d');
    this.myChart = null;

    this.legendMultiSelect = false;

    this.savedDataPoint = {

    }


    this.salaryGroup = "Standard";


    // Bindings
    this.loadData = this.loadData.bind(this);
    this.loadStatistics = this.loadStatistics.bind(this);
    this.setupChart = this.setupChart.bind(this);
    this.externalTooltipHandlerWrapper = this.externalTooltipHandlerWrapper.bind(this);


  
    // Functions
    this.init()
  }



  init()
  { 
    this.loadData();

    this.setupGlobalEvents();
  }

  setupGlobalEvents()
  {
    EventBus.addEventListener(EventTypes.CHART_GLOBALFILTER_UPDATE, event => 
    {
      this.setHighlightedData(event);
    });


    EventBus.addEventListener(EventTypes.SALARY_LEGEND_UPDATE, event => 
    {
      const { 
        chartElement,
        salaryGroup 
      } = event.detail;



      // We update the salary legend on every chart that has the salary legend, whenever we click on it
      // This below updates the salary "selected" state on any other salary legend than the one you click on
      if(chartElement.getAttribute("data-component") != this.el.getAttribute("data-component"))
      {
        updateSalaryLegendStyle(this.el, salaryGroup);
      }

      this.salaryGroup = salaryGroup;
      this.setupChart();
    });
  }

  setHighlightedData(event)
  {  
    const { 
      dataComponent,
      highlightedGroups,
      hidePublicLeaders
    } = event.detail;

    // Only update if its the component requesting
    if(dataComponent === this.el.getAttribute("data-component") || dataComponent == "all")
    {
      // Remove / Add leaders depending of what is selectdd
      this.toggleLeadersVisibility(hidePublicLeaders);


      // Highlight
      this.myChart.data.datasets.forEach((dataset) => 
      {
        
        if(highlightedGroups.includes(dataset.label))
        {
          // Highlighted
          dataset.pointRadius = 6;
          dataset.pointHoverRadius = 7;

        }
        else if(highlightedGroups.length == 0)
        {
          // Noone is highlighted
          dataset.pointRadius = 5;
          dataset.pointHoverRadius = 7;
        }
        else{
         // The ones that are not highlighted 
         dataset.pointRadius = 3;
         dataset.pointHoverRadius = 7;
        }
  
      });


      // Update rendering
      this.calculateAxis();
    }

  }

  toggleLeadersVisibility(hidePublicLeaders)
  {

    if(hidePublicLeaders)
    {
      this.removeData();
    
    }
    else{
      // Show
      this.addData();
    }
  }



  addData()
  {
    // Only add if data is there
    if(this.savedDataPoint.index != null)
    {
      this.myChart.data.datasets.splice(this.savedDataPoint.index, 0, this.savedDataPoint.dataset);
      this.myChart.update();

      // Reset
      this.savedDataPoint.index = null;
    }
    
  }



  removeData()
  {
    if(this.savedDataPoint.index == null)
    {
      this.savedDataPoint = {
        index: null,
        dataset: null
      } 

      this.myChart.data.datasets.forEach((dataset, index) => {
        if(dataset.label == "Offentlige chefer")
        {
          this.savedDataPoint.index = index;
          this.savedDataPoint.dataset = dataset;
        }      
      });

      // Remove at specific point
      this.myChart.data.datasets.splice(this.savedDataPoint.index, 1);

      this.myChart.update();
    }
  }

  setupChart()
  {
    if(this.myChart){
      this.myChart.destroy();
      this.savedDataPoint.index = null;
    }

 

    if(this.ctx)
    {
      // Global config
      setGlobalChartConfig();


      // Data

      const dataSetsFiltered = [];

      this.data[this.salaryGroup].forEach(d => 
      {       
        // Init dataset
        var dataset = {
          label: "",
          data: [],
          pointStyle: 'circle',
          pointRadius: 4,
          pointHoverRadius: 6,
          borderColor: getRootVariable("--color-dark-gray"),
          pointBackgroundColor: [],
          pointBorderColor: [],
          borderWidth: 1
        };

        if(d.Group)
        {
          dataset.label = d.Group;
        }

        if(d.Staten) 
        {
          dataset.data.push({
      
            x: d.Staten,
            y: d.Group
          })
          dataset.pointBackgroundColor.push(SectorColors.Staten);
          dataset.pointBorderColor.push(SectorColors.Staten);
        }

        if(d.Kommuner) 
        {
          dataset.data.push({
       
            x: d.Kommuner,
            y: d.Group,
   
          })
          dataset.pointBackgroundColor.push(SectorColors.Kommuner);
          dataset.pointBorderColor.push(SectorColors.Kommuner);
        }

        if(d.Regioner) 
        {
          dataset.data.push({
      
            x: d.Regioner,
            y: d.Group,
         
          })
          dataset.pointBackgroundColor.push(SectorColors.Regioner);
          dataset.pointBorderColor.push(SectorColors.Regioner);
        }

        // Add to general datasets array
        dataSetsFiltered.push(dataset);
      })


      //console.log("dataSetsFiltered", dataSetsFiltered);


      this.myChart = new Chart(this.ctx, 
        {
        type: 'line',
        data: 
        {
            
            datasets: dataSetsFiltered
        },
        options: 
        {
            indexAxis: 'y',
            interaction: {
              intersect: true,
              mode: 'nearest',
            },
            layout: {
              padding: 0
            },
            scales:
            {
              x:
              {
                position: "top",
                ticks: {
                  autoSkip: true,
                  maxRotation: 0,
                  major: {
                    enabled: true
                  },
                  padding: 20
                },
                grid: {
                  display: false,
                  offset: false,
                  drawBorder: false,
                  padding: 20,

           
                },
                title: setChartScaleTitle(),
                padding: 100
              },
               x2: 
               {
                title: setChartScaleTitle(),
                position: "bottom",
                ticks: {
                  autoSkip: true,
                  maxRotation: 0,
                  major: {
                    enabled: true
                  },
                  padding: 20
                },
                grid: {
                  display: false,
                  offset: false,
                  drawBorder: false,
                  drawOnChartArea: false
  
                }
              },  
              y:{
                
                ticks: {
                  mirror: false,
                  color: getRootVariable('--color-dark-gray'),             
                  padding: 10,
                  labelOffset: 0,
                  
                },
                grid: {
                  offset: true,
                  display: true,
                  drawBorder: false
                }  
              }
            },
            plugins: {
              htmlLegend: {
                containerID: 'legend-container',
              },
              legend: {
                display: false,
              },
              tooltip: {
                enabled: false,    
                external: this.externalTooltipHandlerWrapper,
     
              },
            }
        }
      });



      

      this.calculateAxis();



      // Check for Global filter
      const eventData = {
        detail: this.el.getAttribute("data-component")
      }
      const ev = new CustomEvent(EventTypes.CHART_GLOBALFILTER_REQUEST, eventData)
      EventBus.dispatchEvent(ev);


    }
  }

  calculateAxis(){
    // Set same Y scale values
    this.myChart.options.scales.x.min =  this.getLowestXValue();
    this.myChart.options.scales.x.max =  this.getHighestXValue();
    this.myChart.options.scales.x2.min = this.myChart.options.scales.x.min; 
    this.myChart.options.scales.x2.max = this.myChart.options.scales.x.max; 

    this.myChart.update();
  }


  getHighestXValue()
  {
    let value = 0;

    this.myChart.data.datasets.forEach((dataset) => 
    {
      if(dataset.hidden == false || dataset.hidden == null)
      {
        const highest = Math.max(...dataset.data.map(d => d.x));

        if(value < highest)
        {
          value = highest;
        }
      }
    });

    // Round up to nearest 100sh
    value = Math.ceil(value  / 100) * 100;

    return value;
  }

  getLowestXValue()
  {
    let value = 99999999999;

    this.myChart.data.datasets.forEach((dataset) => 
    {
      if(dataset.hidden == false || dataset.hidden == null)
      {
        const lowest = Math.min(...dataset.data.map(d => d.x));

        if(value > lowest)
        {
          value = lowest;
        }
      }
    });

    // Round down to nearest 100
    value = Math.floor((value) / 100) * 100;

    return value;
  }

  externalTooltipHandlerWrapper(context)
  {
    var pointTitle = ``;
    var pointValue = ``;

    const { tooltip} = context;

    if (tooltip.body)
    {
      const bodyLines = tooltip.body.map(b => b.lines);
      bodyLines.forEach((b, i) => 
      {
          const myArray = b[0].split(":");
          const group = myArray[0].trim();


          pointValue = parseFloat(myArray[1].trim().replace(",", "."));
          

          // Get data based on value
          const datapointData = this.data[this.salaryGroup].filter(p => p.Group === group)[0];

          var keys = Object.keys(datapointData);

          keys.forEach(key => 
          {
              var formattetDatapoint = datapointData[key].replace(",", ".");

              var keyValue = parseFloat(formattetDatapoint);

              if(keyValue === pointValue)
              {
                pointTitle = key;
              }
          });
      });
    }

    externalTooltipHandlerCustom(context, pointTitle, `${Math.round(pointValue)} kr`);
  }



  async loadData()
  {
    this.data = await getEndpoint(ENDPOINT_LOENSEKTORER);

    if(this.data)
    {
      this.setupChart();
    }
  }

  async loadStatistics()
  {
    this.dataStatisticsExperience = await getEndpoint(ENDPOINT_STATISTICS_EXPERIENCE);

    if(this.dataStatisticsExperience)
    {
      this.dataStatisticsEducation = await getEndpoint(ENDPOINT_STATISTICS_EDUCATION);

      if(this.dataStatisticsEducation)
      {
        // Loop through first on and find similar matches in seccond array
        this.dataStatisticsExperience.Sheet1.forEach(exp => 
        {
          this.dataStatisticsEducation.Sheet1.forEach(edu => 
          {
            if(exp.Group === edu.Group)
            {
               // Merge eduction into the object of the first one
              exp.Education = edu;
            }
          })
        })

         // When you want to dislay it in the toolt
         //console.log("this.dataStatisticsExperience", this.dataStatisticsExperience);
      }
    }
  }






}
